<mat-form-field class="flex flex-row flex-1" floatLabel="never" [formGroup]="form">
  <label>
    <app-icon *ngIf="locationControl.hasValidator(requiredValidator)" icon="asterisk" aria-hidden="true" size="10"></app-icon>
    {{ orgUnits ? 'Incada Org Unit' : 'Incada Site' }}
  </label>
  <div class="autocomplete-input flex flex-row">
    <input type="text" matInput appNoHtmlTags trim [formControlName]="controlName"
      [matAutocomplete]="locationAuto">
    <button matSuffix mat-icon-button aria-label="Clear"
      [ngStyle]="{'visibility': (locationControl.value) ? 'visible' : 'hidden'}"
      (click)="locationControl.reset()" [disabled]="locationControl.disabled">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-autocomplete #locationAuto="matAutocomplete">
    <mat-option *ngFor="let location of filteredLocations" [value]="location.name"
      matTooltip="{{location.name}}" matTooltipPosition="after" matTooltipClass="my-custom-tooltip">
      {{location.name}}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="locationControl.errors?.['NoOptionsError']">No locations available.</mat-error>
  <mat-error *ngIf="locationControl.errors?.['required']">{{ orgUnits ? 'Org Unit' : 'Site' }} required.</mat-error>
  <mat-error *ngIf="locationControl.errors?.['InvalidOptionError']">{{ orgUnits ? 'Org Unit' : 'Site' }} is invalid.</mat-error>
</mat-form-field>
